<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import MessageInsightPanel from '../MessageInsightPanel.vue';
import { readMessageIntelligence } from '../intelligence.js';
import FileIcon from 'next/icon/FileIcon.vue';

const { attachments, contentAttributes } = useMessageContext();

const { t } = useI18n();

const attachment = computed(() => {
  return attachments.value[0] || {};
});

const url = computed(() => {
  return attachment.value.dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});

const ocrInsight = computed(() =>
  readMessageIntelligence({
    type: 'ocr',
    contentAttributes: contentAttributes.value,
    attachment: attachment.value,
  })
);
</script>

<template>
  <div class="flex w-full max-w-[34rem] flex-col gap-2">
    <BaseAttachmentBubble
      icon="i-teenyicons-user-circle-solid"
      icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
      sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
      :content="decodeURI(fileName)"
      :action="{
        href: url,
        label: $t('CONVERSATION.DOWNLOAD'),
      }"
    >
      <template #icon>
        <FileIcon :file-type="fileType" class="size-4" />
      </template>
    </BaseAttachmentBubble>
    <MessageInsightPanel
      :title="t('CONVERSATION.MESSAGE_INSIGHTS.OCR.TITLE')"
      :body="ocrInsight.text"
      :state="ocrInsight.state"
      :loading-label="t('CONVERSATION.MESSAGE_INSIGHTS.OCR.LOADING')"
      :error-label="t('CONVERSATION.MESSAGE_INSIGHTS.OCR.ERROR')"
    />
  </div>
</template>
